import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SingleButton from "../../components/SingleButton";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from "moment";

/**
 * Debugging Switch to activate Console Logging for Stages
 * @type {boolean}
 */
const DEBUG = true;

class StageTam6000Cancelled extends React.Component {

    constructor(props){
        super(props);
        // console.log( "FNX: Stage0Welcome props");
        // console.log(props);
        this.state = { selectedOption: '' }
    }

    handleOnChange = (e) =>  {
        if( DEBUG ) console.log( "FNX: selected option" + e.target.value);
        this.setState({ selectedOption: e.target.value});
    }

	/**
	 * Redirect zum Retourenportal
	 */
	gotoRetourenportal = () => {
    	var redirectUrl = "https://www.vodafone.de/retoure?request-id=" + this.props.ds360APIResult.SAP_LIEFERSCHEIN + "&post-code=" + this.props.ds360APIResult.KAS_LOK_PLZ ;
        if( DEBUG ) console.log( "FNX: MainPage.js / construct / props");
        window.open(redirectUrl);
    };

    /**
     * render
     * @returns {*}
     */
    render() {

        let WelcomeText;
        if(this.props.validationDone){
            WelcomeText = <Header
            textResource={"tam6000_cancelled_title"}
            name={`${this.props.apiData.firstName}`}
			/>
		}else{
			WelcomeText = <Header
			textResource={"tam6000_cancelled_title"}
			name={`${this.props.apiData.firstName} ${this.props.apiData.lastName} `}
			/>
		}

		const headerAndWelcomeText = <div>
			{WelcomeText}
			<div style={{marginTop:"20px"}}>
				<TextBody
					textResource={"tam6000_cancelled_body_2"}
				/>
			</div>
		</div>;

		const statusBar = <StatusOverview
		showDescription={true}
			/>;

		/**
		 * Top Navigation / "Footer" Link
		 */
		const footerLnk = <TopNav
		buttonTextResource={"footer_link"}
		buttonOnClick={this.props.openTopNav}
		/>;

		return <Container>

			<MobileView>
				<Row className={"header"}>
					<Col xs={2} style={{marginLeft:"-15px"}}>
						<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
					</Col>
				</Row>
				<Row style={{paddingTop:"5vh"}}>
					<Col xs={{ size: 12 }}>
						{headerAndWelcomeText}
						<SpacerRow/>
					</Col>
				</Row>
				<Row className={'fixed-to-bottom'} style={{paddingBottom:"20px"}}>
					<Col xs={{ size: 12 }}>
						<BottomBar
							// mainButtonOnClick={this.props.nextStage}
							mainButtonOnClick={() => {
								// zum Retourenportal
								this.gotoRetourenportal();
								// this.props.tam6000SubmitCallback(this.state.selectedOption)
							}}
							mainButtonTextResource={"tam6000_cancelled_button"}
						/>
					</Col>
				</Row>
			</MobileView>

			<BrowserView>
				<Row className={"header desktop"}>
					<Col xs={12}>
						<div className={"container"}>
							<Row>
								<Col xs={2} style={{marginLeft:"-15px"}}>
									<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
				<Row style={{paddingTop:"20vh"}}>
					<Col xs={{ size: 10, offset: 1 }}>
						{headerAndWelcomeText}
						<SpacerRow/>
					</Col>
				</Row>
				<Row>
					<Col xl={{ size: 3, offset: 1 }} lg={{ size: 4, offset: 1 }} md={{ size: 5, offset: 1 }} sm={{ size: 7, offset: 1 }} xs={{ size: 12, offset: 0 }} >
						<BottomBar
							// mainButtonOnClick={this.props.nextStage}
							mainButtonOnClick={() => {
								// zum Retourenportal
								this.gotoRetourenportal();
								// this.props.tam6000SubmitCallback(this.state.selectedOption)
							}}
							mainButtonTextResource={"tam6000_cancelled_button"}
						/>
					</Col>
				</Row>
			</BrowserView>

			</Container>
		}
}

export default translate("translations")(StageTam6000Cancelled);